var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-list-item",
        { staticClass: "text-center" },
        [
          _c(
            "v-btn",
            {
              staticClass: "quick_help_button",
              attrs: {
                id: _vm.idPrefix + "_QuickHelp",
                href: _vm.helpLink,
                target: "_blank",
                icon: ""
              }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attr = ref.attr
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              _vm._b(
                                { staticClass: "material-icons-outlined" },
                                "v-icon",
                                attr,
                                false
                              ),
                              on
                            ),
                            [_vm._v("\n            help_outline\n          ")]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { id: _vm.idPrefix + "_Help_TooltipText" } },
                    [_vm._v("Open the user guide")]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }